import React, { useState } from "react";
import TwitterDashboard from "../components/dashboards/TwitterDashboard.js";
import TelegramDashboard from "../components/dashboards/TelegramDashboard.js";
import { MailIcon } from "../components/icons";
import "./css/ResearchScreen.css";

const DASHBOARDS = [
  { id: "twitter", label: "Twitter" },
  { id: "telegram", label: "Telegram" },
];

const CONTACTS = [
  { name: "Prof Ilan Manor", email: "manor.ilan@gmail.com" },
  { name: "Prof Orly Manor", email: "orlyma@ekmd.huji.ac.il" },
];

function ResearchScreen() {
  const [selectedDashboard, setSelectedDashboard] = useState(null);
  const universitiesLogos = `${process.env.PUBLIC_URL}/universitiesLogos.png`;

  return (
    <div className="research-screen">
      {/* Title and explanation */}
      <header className="research-hero">
        <div className="research-container">
          <h1>Welcome to the Research Platform</h1>
          <p>
            The data includes various channels covering politics, foreign
            administration, and newspapers, specifically focusing on the war
            that began on October 7th. You can filter the data according to
            your preferences.
          </p>
        </div>
      </header>

      <main className="research-container research-main">
        {/* Dashboards */}
        <section className="research-panel">
          <h2>Select a Dashboard</h2>
          <div className="segmented" role="group" aria-label="Select a Dashboard">
            {DASHBOARDS.map(({ id, label }) => (
              <button
                key={id}
                type="button"
                className={`segmented-option ${
                  selectedDashboard === id ? "is-active" : ""
                }`}
                aria-pressed={selectedDashboard === id}
                onClick={() => setSelectedDashboard(id)}
              >
                {label}
              </button>
            ))}
          </div>
          {selectedDashboard && (
            <div className="dashboard-content">
              {selectedDashboard === "twitter" && <TwitterDashboard />}
              {selectedDashboard === "telegram" && <TelegramDashboard />}
            </div>
          )}
        </section>

        {/* Contact */}
        <section className="research-contact">
          <h2>Contact Us</h2>
          <div className="contact-list">
            {CONTACTS.map(({ name, email }) => (
              <a key={email} className="contact-card" href={`mailto:${email}`}>
                <span className="contact-icon">
                  <MailIcon />
                </span>
                <span className="contact-text">
                  <span className="contact-name">{name}</span>
                  <span className="contact-email">{email}</span>
                </span>
              </a>
            ))}
          </div>
        </section>
      </main>

      <footer className="research-footer">
        <img
          src={universitiesLogos}
          alt="Ben-Gurion University of the Negev and The Hebrew University of Jerusalem"
          className="research-logos"
        />
      </footer>
    </div>
  );
}

export default ResearchScreen;
